// Module
var code = "<template>\r\n  <require from=\"./resources/css/w3.css\"></require>\r\n  <require from=\"./resources/css/custom.css\"></require>\r\n  <require from=\"./resources/css/font-awesome.min.css\"></require>\r\n  <router-view></router-view>\r\n</template>\r\n";
// Exports
export default code;